import { RECENT_SUBJECT_PATH, MAX_RECENT_SUBJECTS } from 'data/investors';

// Recent subject properties for the Investor Search surface.
//
// Same behaviour as the main search bar (most-recent first, de-duplicated on
// the lower-cased label, capped), but under this surface's OWN key — clearing
// recents here must never clear the main search's list, and vice versa.
export const getRecentSubjects = () => {
  try {
    return JSON.parse(window.localStorage.getItem(RECENT_SUBJECT_PATH)).filter(
      (i) => Boolean(i) && Boolean(i.label)
    );
  } catch (e) {
    return [];
  }
};

const write = (items) => {
  try {
    window.localStorage.setItem(RECENT_SUBJECT_PATH, JSON.stringify(items));
  } catch (e) {
    // Storage unavailable (private mode / quota) — recents are a convenience,
    // so fall through and keep the in-memory list.
  }

  return items;
};

export const addRecentSubject = (item) => {
  const key = ((item && item.label) || '').trim().toLowerCase();
  if (key === '') return getRecentSubjects();

  const items = getRecentSubjects().filter((s) => s.key !== key);
  items.unshift({ ...item, key });
  items.length = Math.min(items.length, MAX_RECENT_SUBJECTS);

  return write(items);
};

export const removeRecentSubject = (key) => write(getRecentSubjects().filter((s) => s.key !== key));

export const clearRecentSubjects = () => write([]);
